/**
 * Microsoft Clarity helpers.
 */

type ClarityQueue = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

declare global {
  interface Window {
    clarity?: ClarityQueue;
  }
}

export const isClarityEnabled = (): boolean => (import.meta.env.VITE_CLARITY_PROJECT_ID || "").trim().length > 0;

export const identifyClarityUser = (customId: string, friendlyName?: string): void => {
  if (!customId || !window.clarity) return;
  window.clarity("identify", customId, undefined, undefined, friendlyName);
};

export const setClarityTag = (key: string, value: string): void => {
  if (!key || !value || !window.clarity) return;
  window.clarity("set", key, value);
};

export const upgradeClaritySession = (reason: string): void => {
  if (!window.clarity) return;
  window.clarity("upgrade", reason);
};
